import { Component, Input, OnDestroy, OnInit } from "@angular/core";

import { ParentEventFromSearch } from "../event-page-models/parent-event-from-search";
import { EventStatus } from "../event-page-models/event-status";
import { eventPageUtils } from "../utils/event-page-utils";
import { getEnumNumbers } from "../../../_helpers/enum-utils";
import { EventsService } from "../../../_services/eventsServices/events.service";
import { ChildEvent } from "../event-page-models/child-event";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";

@Component({
  selector: "parent-events-row-details",
  templateUrl: "./parent-events-row-details.component.html",
  styleUrls: [
    "../parent-events-row/parent-events-row.component.scss",
    "./parent-events-row-details.component.scss",
  ],
})
export class ParentEventsRowDetailsComponent implements OnInit, OnDestroy {
  public childEvents: ChildEvent[];
  private parentEvent: ParentEventFromSearch;

  constructor(
    private eventsService: EventsService,
    private dataService: DataService,
    private authenticationService: AuthenticationService
  ) {}

  // tslint:disable-next-line:no-empty

  @Input("parentEvent")
  public set setParentEvent(parentEvent: ParentEventFromSearch) {
    this.parentEvent = parentEvent;
    this.childEvents = parentEvent.childEvents;
    // this.eventsService
    //   .getChildEventsFromParentEvent(parentEvent)
    //   .subscribe((childEvents) => {
    //     this.childEvents = childEvents;
    //   });
  }

  public static buildStatusOptions() {
    return getEnumNumbers(EventStatus).map((n) => ({
      text: eventPageUtils.eventStatusToText(n),
      value: n,
    }));
  }

  // tslint:disable-next-line:no-empty
  ngOnInit(): void {}

  ngOnDestroy(): void {}

  public formatDate(date: Date) {
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  changeStatus($event: Event) {}
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-row-details/parent-events-row-details.component.ts